var concat = require('../array/virtual/concat');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.concat;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.concat) ? concat : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/concat.js
// module id = 985
// module chunks = 0